import { render, staticRenderFns } from "./mobileMyGame.vue?vue&type=template&id=097bc1ff&scoped=true&"
import script from "./mobileMyGame.vue?vue&type=script&lang=js&"
export * from "./mobileMyGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097bc1ff",
  null
  
)

export default component.exports